<template>
  <div class="container clearfix">
    <leftBox/>
    <rightBox/>

    <topicDialog
      ref="refTopicDialog"
      :dialog-state="dialogState"
      @event-dialog-close="eventDialogClose"></topicDialog>
  </div>
</template>

<script>
import leftBox from "@/components/leftBox";
import rightBox from "@/components/rightBox";
import topicDialog from "@/components/panel/topicDialog";
import bus from "@/utils/eventBus";
export default {
  name: 'topicView',
  data(){
    return{
      dialogState: false
    }
  },
  mounted() {
    bus.on("openNewTopic",(htmlStr)=>{
      let me = this;
      this.dialogState = true;
      setTimeout(()=>{
        me.$refs.refTopicDialog.setContext(htmlStr)
      },500)

    });
  },
  methods:{
    eventDialogClose: function (){
      this.dialogState = false
    }
  },
  components: {
    leftBox,
    rightBox,
    topicDialog
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0px;
  box-sizing: border-box;
}
body{
  margin: 0px;
}
.container{
  overflow: hidden;
}
.clearfix::after
{
    content:"";
    clear:both;
    display:table;
}
pre{
  background-color: #2B2B2B !important;
  color: #fff !important;
}
</style>
